import { useEffect, useState } from 'react'

import { useWindowStore } from 'modules/desktop/pages/MainPage/stores'
import { usePrefersReducedMotion } from 'shared/hooks/usePrefersReducedMotion'
import { useWallpaperStore } from 'shared/stores/wallpaperStore'
import { useAnimatedWallpaperScene } from 'shared/wallpapers/useAnimatedWallpaperScene'

import styles from './AnimatedWallpaper.module.scss'
import { LayeredWallpaper } from './LayeredWallpaper/LayeredWallpaper'

export const AnimatedWallpaper = () => {
  const reducedMotion = usePrefersReducedMotion()
  const wallpaperId = useWallpaperStore(state => state.currentWallpaper.id)
  const definition = useAnimatedWallpaperScene(wallpaperId)
  const [visible, setVisible] = useState(
    () => typeof document === 'undefined' || !document.hidden
  )
  // Conservative coverage policy: stop even if a maximized app is translucent.
  // Subscribe to the boolean so window dragging does not re-render this layer.
  const covered = useWindowStore(state =>
    state.windows.some(
      window => window.isVisible && !window.isMinimized && window.isMaximized
    )
  )

  useEffect(() => {
    const update = () => setVisible(!document.hidden)
    update()
    document.addEventListener('visibilitychange', update)
    return () => document.removeEventListener('visibilitychange', update)
  }, [])

  const poster = definition
    ? `${definition.assetBaseUrl}${definition.poster}`
    : undefined
  const thumbnail = definition
    ? `${definition.assetBaseUrl}${definition.thumbnail}`
    : undefined
  useEffect(() => {
    if (poster)
      useWallpaperStore
        .getState()
        .updateCurrentWallpaperAssets(wallpaperId, poster, thumbnail)
  }, [wallpaperId, poster, thumbnail])

  // Only the selected definition mounts. Inactive scenes release their DOM
  // layers and cancel native animations; React never updates animation frames.
  if (!definition || reducedMotion || !visible || covered) return null

  return (
    <div className={styles.animatedWallpaper} aria-hidden='true'>
      <LayeredWallpaper key={definition.key} definition={definition} />
    </div>
  )
}
